module.exports = __webpack_public_path__ + "img/logo_rectangle_white.4f622800.png";